<div class="aina-chat mt-4">
  <xen-title-section
    title="Need help? Let's solve it together!"
    subtitle="Help us understand your situation better by describing your request in as much detail as possible."
  ></xen-title-section>

  <div class="mt-3" [formGroup]="form">
    <xen-textarea
      formControlName="question"
      id="onboarding-aina-question"
      name="onboarding-aina-question"
      [placeholder]="placeholder"
      [validation]="true"
      [validation_status]="form.get('question').dirty && form.get('question').invalid ? 'is-invalid' : ''"
      [feedback]="
        form.get('question').dirty && form.get('question').invalid ? 'Please enter at least 5 characters.' : ''
      "
      [rows]="8"
    ></xen-textarea>

    <div class="mt-2 custom-btn-width">
      <xen-btn
        [type]="'primary'"
        [size]="'medium'"
        [label]="'Ask AIna'"
        [icon]="true"
        [icon_placement]="'right'"
        [icon_snippet]="'fa-regular fa-sparkles'"
        [skin]="'gray'"
        (clicked)="askAina()"
      ></xen-btn>
    </div>
  </div>
</div>
